export default "__VITE_ASSET__f3f7c20a__"